
import React, { useState } from 'react';
import { SOCIAL_LINKS, SocialIcon } from '../components/SocialIcons';

const Contact: React.FC = () => {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'Consulta de Pedido',
    message: ''
  });

const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();

  const form = e.currentTarget; // now HTMLFormElement

  setStatus('submitting');

  try {
    const response = await fetch("https://formspree.io/f/mbddlzjp", {
      method: "POST",
      body: new FormData(form),
      headers: {
        Accept: 'application/json',
      },
    });

    if (response.ok) {
      setStatus('success');
      setFormData({ name: '', email: '', subject: 'Consulta de Pedido', message: '' });
    } else {
      setStatus('error');
    }
  } catch {
    setStatus('error');
  }
};


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="layout-container flex h-full grow flex-col bg-white">
      <div className="px-4 md:px-10 lg:px-40 flex flex-1 justify-center py-10 md:py-20">
        <div className="layout-content-container flex flex-col max-w-[960px] flex-1">
          
          {status === 'success' ? (
            <div className="flex flex-col items-center justify-center py-20 text-center animate-fade-in">
              <div className="size-20 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                <span className="material-symbols-outlined text-5xl text-primary font-bold">check</span>
              </div>
              <h2 className="text-3xl font-black uppercase italic tracking-tighter mb-4">¡Mensaje Recibido!</h2>
              <p className="text-gray-500 max-w-sm mb-8">
                Tu transmisión ha llegado al muro de boxes. Nuestro equipo técnico te responderá en menos de 24 horas.
              </p>
              <button 
                onClick={() => setStatus('idle')}
                className="bg-black text-white px-10 py-4 rounded-xl font-bold uppercase tracking-widest italic hover:bg-neutral-800 transition-all"
              >
                Enviar otro mensaje
              </button>
            </div>
          ) : (
            <>
              <div className="mb-10 md:mb-16 pt-4 md:pt-8 text-center md:text-left">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-black tracking-tighter uppercase mb-6 italic leading-none">
                  Soporte de <span className="text-primary">Precisión</span>
                </h1>
                <p className="text-gray-500 text-sm md:text-lg font-normal max-w-2xl">
                  Si tienes preguntas sobre nuestros productos, nuestro equipo está listo para responderte.
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 md:gap-16 pb-20">
                <div className="lg:col-span-7">
                  <form onSubmit={handleSubmit} className="flex flex-col gap-6 md:gap-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-2">
                        <p className="text-black text-[10px] font-black uppercase tracking-widest italic ml-1">Nombre</p>
                        <input 
                          required
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="w-full h-14 bg-gray-50 border border-transparent focus:border-primary/30 rounded-xl px-4 outline-none focus:ring-4 focus:ring-primary/5 transition-all font-medium text-sm" 
                          placeholder="Tu nombre completo" 
                        />
                      </div>
                      <div className="space-y-2">
                        <p className="text-black text-[10px] font-black uppercase tracking-widest italic ml-1">Correo Electrónico</p>
                        <input 
                          required
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="w-full h-14 bg-gray-50 border border-transparent focus:border-primary/30 rounded-xl px-4 outline-none focus:ring-4 focus:ring-primary/5 transition-all font-medium text-sm" 
                          placeholder="ejemplo@correo.com" 
                        />
                      </div>
                    </div>
                    <div className="space-y-2">
                      <p className="text-black text-[10px] font-black uppercase tracking-widest italic ml-1">Asunto</p>
                      <select 
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        className="w-full h-14 bg-gray-50 border border-transparent focus:border-primary/30 rounded-xl px-4 outline-none focus:ring-4 focus:ring-primary/5 transition-all appearance-none text-gray-500 font-bold text-xs uppercase tracking-widest"
                      >
                        <option>Consulta de Pedido</option>
                        <option>Venta al por mayor</option>
                        <option>Prensa</option>
                        <option>Otros</option>
                      </select>
                    </div>
                    <div className="space-y-2">
                      <p className="text-black text-[10px] font-black uppercase tracking-widest italic ml-1">Mensaje</p>
                      <textarea 
                        required
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="w-full min-h-[160px] bg-gray-50 border border-transparent focus:border-primary/30 rounded-xl p-4 outline-none focus:ring-4 focus:ring-primary/5 transition-all resize-none font-medium text-sm" 
                        placeholder="¿En qué podemos ayudarte?"
                      ></textarea>
                    </div>
                    
                    <button 
                      type="submit"
                      disabled={status === 'submitting'}
                      className={`h-16 px-12 rounded-xl font-black uppercase tracking-widest transition-all italic flex items-center justify-center gap-3 w-full md:w-fit shadow-xl ${
                        status === 'submitting' 
                          ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                          : 'bg-black text-white hover:bg-neutral-800 active:scale-95'
                      }`}
                    >
                      {status === 'submitting' ? (
                        <>
                          <span className="size-5 border-2 border-gray-300 border-t-primary rounded-full animate-spin"></span>
                          Transmitiendo...
                        </>
                      ) : (
                        'Enviar Mensaje'
                      )}
                    </button>
                    {status === 'error' && (
                      <p className="text-red-500 text-[10px] font-bold uppercase tracking-widest mt-2">Error en la conexión. Reintenta en la siguiente vuelta.</p>
                    )}
                  </form>
                </div>

                <div className="lg:col-span-5 flex flex-col gap-10 md:gap-12 lg:pl-10 lg:border-l lg:border-gray-100">
                  <div>
                    <h3 className="text-black text-base md:text-lg font-black mb-4 flex items-center gap-3 italic uppercase tracking-tighter">
                      <span className="material-symbols-outlined text-primary">flag</span>
                      Sede Central (HQ)
                    </h3>
                    <p className="text-gray-500 text-sm md:text-base leading-loose font-medium">
                      Sabadell, Barcelona <br/>
                  SPAIN
                    </p>
                  </div>
                  <div>
                    <h3 className="text-black text-base md:text-lg font-black mb-4 italic uppercase tracking-tighter">Líneas Directas</h3>
                    <div className="space-y-3">
                      <div className="flex items-center gap-4 p-4 rounded-xl bg-gray-50 hover:bg-white border border-transparent hover:border-gray-100 transition-all group">
                        <div className="size-10 rounded-lg bg-white flex items-center justify-center border border-gray-100 group-hover:bg-primary/10 transition-colors">
                          <span className="material-symbols-outlined text-primary text-xl">mail</span>
                        </div>
                        <span className="font-black text-xs md:text-sm italic">pedidos@sanan-wear.com</span>
                      </div>
                      <div className="flex items-center gap-4 p-4 rounded-xl bg-gray-50 hover:bg-white border border-transparent hover:border-gray-100 transition-all group">
                        <div className="size-10 rounded-lg bg-white flex items-center justify-center border border-gray-100 group-hover:bg-primary/10 transition-colors">
                          <span className="material-symbols-outlined text-primary text-xl">call</span>
                        </div>
                        <span className="font-black text-xs md:text-sm italic">+34 614 409 356</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-black text-base md:text-lg font-black mb-4 italic uppercase tracking-tighter">Redes Sociales</h3>
                    <div className="space-y-3">
                      {SOCIAL_LINKS.map(s => (
                        <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-xl bg-gray-50 hover:bg-white border border-transparent hover:border-gray-100 transition-all group">
                          <div className="size-10 rounded-lg bg-white flex items-center justify-center border border-gray-100 group-hover:bg-primary/10 transition-colors text-primary">
                            <SocialIcon name={s.name} />
                          </div>
                          <span className="font-black text-xs md:text-sm italic">{s.name} · {s.handle}</span>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
